import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import { Button, ZoneModal } from "../../index";
import { getZones } from "../utils";
import Zone from "../zone/Zone";
import { BOARD_ENDPOINTS, BoardObjectTypes } from "../../constants";
function View(props) {
    const { id, ds, dataUrl } = props;
    const [zones, setZones] = useState([]);
    const [open, setOpen] = useState(false);
    const [zoneOrder, setZoneOrder] = useState([]);
    useEffect(() => {
        getZones(id, ds).then((res) => {
            const initialZones = res.zones.map((zone) => {
                return {
                    id: zone.id,
                    objectType: zone.object_type,
                    title: zone.title,
                    filter: zone.filter,
                };
            });
            setZoneOrder(res.order);
            setZones(initialZones);
        });
    }, []);
    const deleteZone = (id) => {
        const newZones = zones.filter((zone) => zone.id !== id);
        ds.custom(`${BOARD_ENDPOINTS.DELETE_ZONE}/${id}`, "DELETE");
        setZones(newZones);
    };
    const onZoneReorder = async (id, direction) => {
        // Sort a copy of zoneOrder array by order
        const updatedZoneOrder = [...zoneOrder];
        updatedZoneOrder.sort((a, b) => a.order - b.order);
        // Find the index of the zone order to move
        const moverIndex = updatedZoneOrder.findIndex((zone) => zone.zoneId === id);
        const delta = direction === "up" ? -1 : 1;
        // Find the zone order to move and the zone order to move it to
        const mover = updatedZoneOrder[moverIndex];
        const moved = updatedZoneOrder[moverIndex + delta];
        // Bounds check
        if (!moved)
            return;
        // Swap the order values
        const oldMoverOrder = mover.order;
        const oldMovedOrder = moved.order;
        mover.order = oldMovedOrder;
        moved.order = oldMoverOrder;
        // Sort again
        updatedZoneOrder.sort((a, b) => a.order - b.order);
        // Get the maximum order value
        const orders = updatedZoneOrder.map((zone) => {
            return zone.order;
        });
        const maxOrder = Math.max(...orders);
        // Add the max offset value to each zone order (This avoids integrity issues in the DB)
        updatedZoneOrder.forEach((zone) => {
            zone.order += maxOrder + 1;
        });
        const payloadData = updatedZoneOrder.map((zone) => {
            return {
                type: BoardObjectTypes.ZONE_VIEW,
                id: zone.zoneViewId,
                attributes: {
                    order: zone.order,
                },
            };
        });
        await ds.upsert({
            objectType: BOARD_ENDPOINTS.VIEW_ZONES,
            payload: payloadData,
        });
        setZoneOrder(updatedZoneOrder);
        // Reorder the zones state based on the updated zoneOrder
        const updatedZones = [...zones].sort((a, b) => {
            const orderA = // @ts-ignore
             updatedZoneOrder.find((zone) => zone.id === a.id)?.order || 0;
            const orderB = // @ts-ignore
             updatedZoneOrder.find((zone) => zone.id === b.id)?.order || 0;
            return orderA - orderB;
        });
        setZones(updatedZones);
    };
    const getSortedZones = () => {
        return [...zones].sort((a, b) => {
            const orderA = zoneOrder.find((zone) => zone.zoneId === a.id)?.order || 0;
            const orderB = zoneOrder.find((zone) => zone.zoneId === b.id)?.order || 0;
            return orderA - orderB;
        });
    };
    return (_jsxs("div", { className: "tol-view", children: [_jsx("div", { className: "tol-view-bar", children: _jsx("div", { style: open ? { display: "none" } : {}, children: _jsx(Button, { onClick: () => {
                            setOpen(true);
                        }, type: "success", className: "add-zone-button" // temp placement
                        , icon: "plus", position: "right" }) }) }), _jsx(ZoneModal, { open: open, setOpen: setOpen, setZones: setZones, zones: zones, zoneOrder: zoneOrder, setZoneOrder: setZoneOrder, ds: ds, viewId: id, dataUrl: dataUrl }), zones.length > 0 ? (_jsx(_Fragment, { children: getSortedZones().map((zone) => {
                    return (_jsx(Zone, { id: zone.id, title: zone.title, objectType: zone.objectType, filter: zone.filter, onZoneReorder: onZoneReorder, deleteZone: deleteZone, ds: ds, dataUrl: dataUrl }, zone.id));
                }) })) : (_jsx("div", { className: "tol-zone-empty", children: _jsx("p", { children: "Click the + button to add a Zone" }) }))] }));
}
export default View;
